import { render, staticRenderFns } from "./MealDesigner.vue?vue&type=template&id=5b0bbc8a&scoped=true&"
import script from "./MealDesigner.vue?vue&type=script&lang=js&"
export * from "./MealDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0bbc8a",
  null
  
)

export default component.exports